import React from "react";
import PropTypes from "prop-types";
import { TreeSelect as AntTreeSelect } from "antd";
import { UiTreeSelect } from "./TreeSelect.style";
/**
 * 多選下拉多層選單
 */
// const { SHOW_PARENT } = AntTreeSelect;

const TreeSelect = ({
  label,
  options,
  onChange,
  value,
  placeholder,
  getPopupContainer = () => document.getElementById("area")
}) => {
  const onChangeHandle = value => {
    onChange && onChange(value);
  };

  return /*#__PURE__*/React.createElement(UiTreeSelect, {
    id: "area"
  }, /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/React.createElement(AntTreeSelect, {
    style: {
      minWidth: "240px",
      maxWidth: "350px"
    },
    placeholder: placeholder,
    treeData: options,
    getPopupContainer: getPopupContainer,
    value: value,
    onChange: onChangeHandle,
    treeCheckable: true
  }));
};

export default TreeSelect;
TreeSelect.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    value: PropTypes.string,
    key: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string,
      key: PropTypes.string
    }))
  })),
  onChange: PropTypes.func,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  getPopupContainer: PropTypes.func
};